import PageErrorBoundary from '@/components/PageErrorBoundary';
import AppRouter from './router';

export default function App() {
  // 顶层兜底：登录页 / 布局本身的 chunk 加载失败也不至于白屏。
  // 页面内容区的错误由 BasicLayout 里那层边界单独接住，侧边栏保持可用。
  return (
    <PageErrorBoundary>
      <AppRouter />
    </PageErrorBoundary>
  );
}
